module.exports = __webpack_public_path__ + "img/mcu3.7a974806.png";